const buttons = {
  primary: {
    fontFamily: 'body',
    px: 5,
    py: 4,
    borderRadius: 0,
  },
  secondary: {
    fontFamily: 'body',
    px: 5,
    py: 4,
    borderRadius: 0,
    borderStyle: 'solid',
    borderWidth: 2,
  },
  tertiary: {
    fontFamily: 'heading',
    bg: 'transparent',
    borderRadius: 0,
    p: 0,
    pb: '2px',
  },
  formInput: {
    fontFamily: 'heading',
    fontSize: 3,
    color: 'black',
    bg: 'sky',
    px: 5,
    py: 4,
    my: 3,
    mr: 3,
    borderRadius: 0,
  },
  icon: {
    primary: {
      fontFamily: 'heading',
      fontSize: 3,
      color: 'white',
      bg: 'primary',
      width: 50,
      height: 50,
      borderRadius: 0,
      '&:hover': {
        bg: 'forest80',
      },
    },
  },
}

export default buttons
